import React from 'react'

import { useSelector } from 'react-redux'
import { FlexItem } from 'styled-flex-component'

import ShareableContentLibraryTrackedRoute from '@components/ShareableContentLibrary/TrackedRoute'
import { SubmissionCardPriceSumaryWrapper } from '@components/Submission/Card/PricePanel/PricePanel.styled'
import { PricePanelStyled, PricePanelWrapper } from '@components/UI/PricePanel/PricePanel.styled'
import { EventTrackingNames } from '@enums'
import { useToggle } from '@hooks/useToggle'
import { IApplicationState } from '@store'
import { selectShareableContentLibraryLicenseOptions } from '@store/mediaObjects'
import ShareableContentLibraryFullPricePanelAmount from './Amount'
import ShareableContentLibraryFullPricePanelPopover from './Popover'

interface IProps {
  mediaObjectId: number
}

export const ShareableContentLibraryFullPricePanel: React.FC<IProps> = ({ mediaObjectId }) => {
  const { toggleIsVisible, toggleHide, toggle } = useToggle()
  // No separate fetchMediaObjectLicenseOptions dispatch needed: the shareable content library
  // API response embeds license_options directly on each IShareableMediaObject, so
  // selectShareableContentLibraryLicenseOptions is already populated by the time this renders.
  const licenses = useSelector((state: IApplicationState) =>
    selectShareableContentLibraryLicenseOptions(state, mediaObjectId),
  )
  return (
    <React.Fragment>
      {toggleIsVisible && (
        <SubmissionCardPriceSumaryWrapper top={0}>
          <ShareableContentLibraryFullPricePanelPopover onHide={toggleHide} licenses={licenses} />
        </SubmissionCardPriceSumaryWrapper>
      )}
      <ShareableContentLibraryTrackedRoute
        hasTracking={!toggleIsVisible}
        eventName={EventTrackingNames.ShareableCLViewPriceSummary}
        mediaObjectId={mediaObjectId}
      >
        <PricePanelStyled onClick={toggle} data-testid="price-panel-container">
          <PricePanelWrapper justifyBetween alignCenter>
            <FlexItem>
              <ShareableContentLibraryFullPricePanelAmount mediaObjectId={mediaObjectId} />
            </FlexItem>
          </PricePanelWrapper>
        </PricePanelStyled>
      </ShareableContentLibraryTrackedRoute>
    </React.Fragment>
  )
}

export default ShareableContentLibraryFullPricePanel
